// Vibe 4's Dropdown treats value={undefined} as uncontrolled and keeps showing the last option the user picked, so a
// dropdown bound to e.g. options.find(...) doesn't clear when the state is reset. null keeps it controlled and empty.
// The Dropdown types don't admit null, hence the cast.
export function dropdownValue<T>(value: T | null | undefined): T {
  return (value ?? null) as T;
}
